import React from 'react';
import { observer } from 'mobx-react';

import companyStore from '../../../../store/CompanyStore';
import Styles from './DaishinExpired.module.scss';

const DAISHIN_COMPANY_ID = '17';

@observer
class DaishinExpired extends React.Component {
  componentDidMount() {
    companyStore.fetchCompany(DAISHIN_COMPANY_ID);
  }

  render() {
    const company = companyStore.company;
    const symbolUrl = company?.symbolLogo?.fullUrl ?? null;
    const characterUrl =
      company?.logoFile?.fullUrl ?? company?.symbolLogo?.fullUrl ?? null;
    const companyName = company?.companyName ?? '퀀텀증권';

    return (
      <div
        className={`w-100 h-100 d-flex flex-column flex-default overflow-hidden`}
      >
        <div className={Styles.Container}>
          <div className={Styles.HeaderContainer}>
            <div className={Styles.HeaderGradientBar} />
            <div className={Styles.Header}>
              {symbolUrl && (
                <img
                  src={symbolUrl}
                  alt={companyName}
                  className={Styles.LogoMini}
                />
              )}
              <span className={Styles.BrandName}>{companyName} 상담봇</span>
            </div>
          </div>

          <div className={Styles.Content}>
            <div className={Styles.Character}>
              {characterUrl && (
                <img
                  src={characterUrl}
                  alt={companyName}
                  style={{
                    width: '200px',
                    height: '200px',
                    objectFit: 'contain',
                    backgroundColor: 'transparent',
                  }}
                />
              )}
            </div>
            <div className={Styles.LabelWrap}>
              <div className={Styles.Title}>
                <p>만료된 상담입니다.</p>
              </div>
              <ul className={Styles.Label}>
                <li>
                  <p>
                    오랫동안 상담을 시작하지 않는 경우 채팅상담 연결이
                    제한됩니다.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DaishinExpired.propTypes = {};

export default DaishinExpired;
